import * as ALARM_CATEGORIES from '../alarmCategories/alarmCategories.constants';

/** LOAD */
export function loadAlarmCategories() {
    return { type: ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD };
}

export function loadAlarmCategoriesSuccess(data: string[]) {
    return { type: ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD_SUCCESS, payload: data };
}

export function loadAlarmCategoriesError(error: any) {
    return { type: ALARM_CATEGORIES.ALARM_CATEGORIES_LOAD_ERROR, payload: error };
}